import { message } from 'antd';
import { t } from 'i18next';
import { AccountResponse, SiteAddressData } from '@/store/SiteSurveyForm/constants';

export interface SiteSurveyOverlayProps {
  visible: boolean;
  onClose: () => void;
  salesforceId?: string | null;
}

export interface FormData {
  accountId?: string;
  salesforceId?: string | null;
  formId?: string | null;
}

export const fetchAccountDataForSurvey = async (
  accountId: string,
  fetchAccountData: (accountId: string) => Promise<AccountResponse>,
  formData: FormData,
): Promise<FormData> => {
  try {
    const SFAccountData = await fetchAccountData(accountId);
    return {
      ...formData,
      accountId: SFAccountData.accountId,
    };
  } catch (error) {
    message.error(t('Failed to fetch account data. Please try again.'));
    throw error;
  }
};

export const isSiteAddressEmpty = (siteAddress?: SiteAddressData): boolean => {
  if (!siteAddress) return true;
  return !siteAddress.streetAddress?.trim() ||
    !siteAddress.city?.trim() ||
    !siteAddress.country?.trim();
};
